import { render, staticRenderFns } from "./AssetsStatusesManager.vue?vue&type=template&id=263ede3e"
import script from "./AssetsStatusesManager.vue?vue&type=script&lang=js"
export * from "./AssetsStatusesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports